// src/features/treinos/utils/epley.js
//
// Epley 1RM — ponto ÚNICO (antes estava inline em workoutLogService). Reusado
// por workoutLogService (gráfico de evolução) e por loadRecommendation (teto).

/** 1RM estimado de Epley: carga × (1 + reps/30). 0 se inválido. */
export function epley1RM(carga, reps) {
  const c = Number(carga);
  const r = Number(reps);
  if (!Number.isFinite(c) || !Number.isFinite(r) || c <= 0 || r <= 0) return 0;
  return c * (1 + r / 30);
}

/** Epley inverso: maior carga prevista p/ `repsAlvo` dado um e1RM. */
export function cargaFromE1RM(e1rm, repsAlvo) {
  const e = Number(e1rm);
  const r = Number(repsAlvo);
  if (!Number.isFinite(e) || e <= 0) return 0;
  const reps = Number.isFinite(r) && r > 0 ? r : 0;
  return e / (1 + reps / 30);
}
